import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const VisualizerLogoGlowBlurListItem = (props) => {
    const { logoGlowBlur, updateVisualizerSettings, maxGlowBlur } = props;

    const onBlurChange = (value) => {
        previewHistoryBatch.start();

        updateVisualizerSettings({
            logoGlowSettings: { blur: value }
        });
    };

    return (
        <SliderListItem
            title='Blur'
            value={logoGlowBlur}
            displayMultiplier={100 / maxGlowBlur}
            min={0}
            max={100}
            step={1}
            onValueChange={onBlurChange}
        />
    );
};

const mapStateToProps = (state) => {
    const logoGlowSettings = state.createPreview.present.videoSettings.visualizer.logoGlowSettings || {};
    const { maxGlowBlur } = state.create.maxValues;

    return {
        logoGlowBlur: logoGlowSettings.blur ?? 3.6,
        maxGlowBlur
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerLogoGlowBlurListItem);
